import React, { useEffect, useRef, useState } from 'react';
import { formatMoney, cardIcon, MAIN_CARD_ID } from './cardsStore';
import { useMaskBalance } from './balanceVisibility';

const PAGE_ANIM_MS = 300; // синхронізовано з .capital-page у StatisticsPage.css
const RATES_CACHE_KEY = 'currency_rates_cache'; // кладе App.jsx (курси monobank)

// Курс купівлі валюти банком — за ним валютні картки рахуються в гривні
export function readRates() {
  try {
    const r = JSON.parse(localStorage.getItem(RATES_CACHE_KEY)) || {};
    return { UAH: 1, USD: Number(r.usdBuy) || 0, EUR: Number(r.eurBuy) || 0 };
  } catch (e) {
    return { UAH: 1, USD: 0, EUR: 0 };
  }
}

// «із 1 джерела», «із 4 джерел»
const sourcesWord = (n) => (n % 10 === 1 && n % 100 !== 11 ? 'джерела' : 'джерел');

const BriefcaseIcon = () => (
  <svg viewBox="0 0 24 24" fill="#fff">
    <path d="M9 4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V6h-1.6V4.6h-2.8V6H9z" />
    <rect x="3" y="6.5" width="18" height="5.5" rx="2" />
    <path d="M3 13h18v4.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <rect x="10.5" y="11" width="3" height="3.2" rx=".8" fill="#22c4d6" />
  </svg>
);

const BackIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12H4M10 6l-6 6 6 6" /></svg>
);

// «Капітал» — усі картки користувача, зведені в гривню.
// cards: [{ id, type, name, currency, balance }] у порядку з головної.
export default function CapitalPage({ cards, onClose }) {
  const [closing, setClosing] = useState(false);
  const maskBalance = useMaskBalance();
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  function close() {
    if (closing) return;
    setClosing(true);
    timer.current = setTimeout(onClose, PAGE_ANIM_MS);
  }

  // Під home-indicator iOS малює фон <body>
  useEffect(() => {
    const original = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#082a2e';
    return () => { document.body.style.backgroundColor = original; };
  }, []);

  const rates = readRates();
  const sources = cards.map((c) => ({
    ...c,
    uah: Number(c.balance || 0) * (rates[c.currency] ?? 0),
    label: c.id === MAIN_CARD_ID ? 'Чорна іменна картка' : c.name,
    icon: cardIcon(c.type) || (c.id === MAIN_CARD_ID ? '/card-icons/black.png' : null),
  }));
  const total = sources.reduce((sum, s) => sum + s.uah, 0);

  return (
    <div className={`capital-page ${closing ? 'closing' : ''}`}>
      <div className="capital-topbar">
        <button type="button" className="capital-back" onClick={close} aria-label="Назад"><BackIcon /></button>
      </div>
      <h1 className="capital-title">Капітал</h1>

      <div className="capital-hero">
        <div className="capital-hero-top">
          <span className="capital-hero-icon"><BriefcaseIcon /></span>
          <span className="capital-currency">UAH</span>
        </div>
        <p className="capital-hero-label">Сума</p>
        <p className="capital-hero-sum">{maskBalance(formatMoney(total, 'UAH'))}</p>
        <div className="capital-hero-info">
          <span className="capital-hero-emoji">🏄</span>
          <p>Ваш капітал складається із {sources.length} {sourcesWord(sources.length)}</p>
        </div>
      </div>

      <div className="capital-grid">
        {sources.map((s) => (
          <div className="capital-tile" key={s.id}>
            {s.icon
              ? <img className="capital-tile-img" src={s.icon} alt="" />
              : <span className="capital-tile-img capital-tile-img--placeholder" />}
            <p className="capital-tile-name">{s.label}</p>
            <p className="capital-tile-sum">{maskBalance(formatMoney(s.uah, 'UAH'))}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
